import styled from 'styled-components';

export const YearsButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  & button {
    padding: 8px;
    min-height: 40px;
  }
`;
